<script setup>

import FormBuilder from "../../../components/ui-components/FormBuilder.vue";
import AccordionContent from "primevue/accordioncontent";
import FeatureBlocker from "../../../components/ui-components/FeatureBlocker.vue";

const model = defineModel()
</script>

<template>
    <div class="max-w-[500px]">
        <FeatureBlocker name="roori_custom_form" version="Pro">
            <form-builder v-model="model.formBuilder"></form-builder>
        </FeatureBlocker>
    </div>
</template>

<style scoped lang="scss">

</style>
